module.exports = function getTranslationTexts(lang, translations){
  const tr = translations.filter((item)=>item.language.code===lang)[0];
  return (tr && tr.language) ? tr.language : undefined;
}